export const fieldNames = ['emailAddress']

export const formLayout = [['emailAddress']]
